import React from 'react';
import './style.scss';
import { API_OwnNft } from 'shared';
import clsx from 'clsx';
import NftRankLine from '../../../../general/nft/rankLine';

interface Props {
  nft: API_OwnNft;
  className?: string;
}

const FightPickDescription = ({ nft, className }: Props) => (
  <div
    className={clsx(
      'home-nft-traits',
      (nft.failed || nft.pending) && 'home-nft-traits-disabled',
      className
    )}
  >
    <div className='home-nft-traits-half'>
      <DescBlock title='NAME'>{nft.name}</DescBlock>
      <DescBlock title='RANK'>
        <NftRankLine rank={nft.rank} />
      </DescBlock>
    </div>
    <div className='home-nft-traits-half'>
      <DescBlock title='CLAN'>{nft.guild}</DescBlock>
      <DescBlock title='LEVEL'>{nft.level}</DescBlock>
    </div>
  </div>
);

interface DescProps {
  title: string;
  children: React.ReactNode;
}

const DescBlock = ({ title, children }: DescProps) => (
  <div className='home-nft-traits-half-block'>
    <div className='home-nft-traits-half-block-title'>{title}</div>
    <div className='body-2 no-wrap'>{children}</div>
  </div>
);

export default FightPickDescription;
